import cn from 'classnames';
import upperFirst from 'lodash/upperFirst';
import { Tooltip, Icon } from 'ht-styleguide';
import styles from './benefit.module.scss';

type BenefitBlockProps = {
  benefitInfo: {
    header: string;
    alternateHeader?: string;
    subheader: string;
    badgeCopy: string;
  };
  containerClass?: string;
  showCheckmark?: boolean;
  checkmarkClass?: string;
};
const BenefitBlock = ({ benefitInfo, containerClass = '', showCheckmark = false, checkmarkClass = '' }: BenefitBlockProps) => {
  const { header, alternateHeader, subheader, badgeCopy } = benefitInfo;

  return (
    <div className={cn(styles.container, containerClass)}>
      {showCheckmark && <Icon name="checkmark-v2" className={cn('lightBlue', styles.checkmarkIcon, checkmarkClass)} />}
      <div>
        <span className={styles.headerWrapper}>
          <h6 className="n900">{alternateHeader || header}</h6>
          {subheader && (
            <Tooltip content={subheader}>
              <Icon name="question" className={styles.questionIcon} />
            </Tooltip>
          )}
        </span>
        <p className="caption lightBlue paddingTop-tiny">{upperFirst(badgeCopy)}</p>
      </div>
    </div>
  );
};

export default BenefitBlock;
